module.exports = __webpack_public_path__ + "static/media/voucher-category-bike.606f9709.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/voucher-category-bike.svg
// module id = 944
// module chunks = 0